export default __webpack_public_path__ + "media/images/contact_us/hero_img-cae7d6041e85069050341548edd0229c.webp";